import { render, staticRenderFns } from "./ClientsEmailOcassion.vue?vue&type=template&id=044ddf6f&scoped=true"
import script from "./ClientsEmailOcassion.vue?vue&type=script&lang=js"
export * from "./ClientsEmailOcassion.vue?vue&type=script&lang=js"
import style0 from "./ClientsEmailOcassion.vue?vue&type=style&index=0&id=044ddf6f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "044ddf6f",
  null
  
)

export default component.exports